import * as React from 'react';
import { Modal, Button } from 'antd';
import AuthContext from 'Context/AuthContext';
import { CreditCardRegistrationFormHandler } from 'components/UserManagement/Profile/CreditCardRegistrationForm/CreditCardRegistrationFormHandler';
import Cookies from 'js-cookie';
import ConfigUtility from 'Core/ConfigUtility';
import moment from 'moment';
import { CardRegistrationNotificationContent } from '.';

export interface Props {
  children?: React.ReactNode;
  showAgainForSesion?: boolean;
}

export interface State {
  visible: boolean;
}

export default class CardRegistrationNotificationView extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;
  handler: CreditCardRegistrationFormHandler;
  userNeverShowRegAgainCookie: string;
  constructor(props: Props) {
    super(props);

    this.state = { visible: false };
    this.handler = new CreditCardRegistrationFormHandler(props);
    this.setNeverCheckAgainCookie = this.setNeverCheckAgainCookie.bind(this);
    this.hideModal = this.hideModal.bind(this);
    this.userNeverShowRegAgainCookie = '';
  }


  async componentDidMount() {
    const config = await ConfigUtility.get();

    //set cookie name to be unique based on user id
    this.userNeverShowRegAgainCookie = config.NeverShowCardRegAgainCookieName + '_' + this.context.data?.id;

    const wasNeverCookieSet = Boolean(Cookies.get(this.userNeverShowRegAgainCookie) || false);
    const userLogged = !!this.context.data;
    const user = this.context.data;
    const showAgain = this.props.showAgainForSesion || !(this.context.data?.shownCardRegistrationForTheDay ?? false);
    console.log("user info", user, userLogged, wasNeverCookieSet, showAgain);
    if (userLogged && user) {
      this.handler.GetRegisteredCreditCard(user?.id!).then(x => {
        const hasCards = !!x.length;
        if (userLogged && !wasNeverCookieSet && !hasCards && showAgain) {
          this.setState({ visible: true });
        }
      }).catch(() => { });
    }
  }

  async setNeverCheckAgainCookie() {
    const config = await ConfigUtility.get();

    Cookies.set(this.userNeverShowRegAgainCookie, 'true',
      { secure: true, expires: moment().add(999, "years").toDate() });
    this.setState({ visible: false });

  }

  hideModal() {
    // Update user to say that they have seen the warning for the day/session
    if (this.context.data) {
      this.context.data.shownCardRegistrationForTheDay = true;
      this.context.Update(this.context.data);
    }

    this.setState({ visible: false });
  }

  getModalButtons() {
    return [<Button key="nca" onClick={this.setNeverCheckAgainCookie} type="default">Never Show Again?</Button>, <Button key="ok" onClick={this.hideModal} type="primary">Ok</Button>];
  }

  render() {
    return (
      <>
        <Modal
          visible={this.state.visible}
          footer={this.getModalButtons()}
          closable={false}
          title="Credit Card Registration Required">
          <CardRegistrationNotificationContent />
        </Modal>
      </>
    );
  }
}
